import React from "react";
import { FileText } from "lucide-react";
import SectionHeader from "../shared/SectionHeader";

/**
 * Terms and Disclaimers Form Section
 * 
 * @param {Object} props Component properties
 * @param {Function} props.register React Hook Form register function
 */
const TermsForm = ({ register }) => (
  <div className="card bg-base-100 border border-base-300">
    <div className="card-body p-6">
      <SectionHeader
        icon={<FileText className="w-6 h-6 text-primary" aria-hidden="true" />}
        title="Terms & Disclaimers"
        description="Legal text displayed during registration"
      />

      <textarea
        className="textarea textarea-bordered w-full min-h-32"
        {...register("disclaimerText")}
        aria-label="Disclaimer Text"
        placeholder="Enter legal disclaimers and terms that will be displayed during registration..."
      ></textarea>
    </div>
  </div>
);

export default TermsForm; 